
import { Behavior, ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from '../buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import thumbnail from './images/world-map.png';
import { EchartsMapChartProps, EchartsMapFormData } from './types';
 
export default class EchartsCountryMapChartPlugin extends ChartPlugin<
   EchartsMapFormData,
   EchartsMapChartProps
 > {
   constructor() {
     super({
       buildQuery,
       controlPanel,
       loadChart: () => import('./EchartsMap'),
       metadata: new ChartMetadata({
         behaviors: [Behavior.INTERACTIVE_CHART],
         category: t('Map'),
         credits: ['https://echarts.apache.org'],
         description:
           t(`World map`),
         exampleGallery: [
           { url: thumbnail },
         ],
         name: t('World Map'),
         tags: [
           t('ECharts'),
           t('Maps'),
         ],
         thumbnail,
       }),
       transformProps,
     });
   }
}
 